import AnalyticsNavbar from "./components/AnalyticsNavbar";
import AnalyticsHero from "./components/AnalyticsHero";
import AnalyticsHowItWorks from "./components/AnalyticsHowItWorks";
import AnalyticsDemoReports from "./components/AnalyticsDemoReports";
import AnalyticsAdvantages from "./components/AnalyticsAdvantages";
import AnalyticsCalculator from "./components/AnalyticsCalculator";
import AnalyticsContactForm from "./components/AnalyticsContactForm";
import AnalyticsFooter from "./components/AnalyticsFooter";
import SeoHead from "@/components/feature/SeoHead";
import { analytics } from "@/content";

/**
 * Модуль расширенной аналитики.
 * Адрес один (`/analytics`) — тема переключается без смены URL.
 */
export default function AnalyticsPage() {

  return (
    <>
      <SeoHead
        title={analytics.seo.title}
        description={analytics.seo.description}
        keywords={analytics.seo.keywords}
        canonicalPath={analytics.seo.canonicalPath}
      />
              <div className="min-h-screen font-sans bg-white dark:bg-[#0A0A0A]">
          <AnalyticsNavbar />
          <main>
            <AnalyticsHero />
            <AnalyticsHowItWorks />
            <AnalyticsDemoReports />
            <AnalyticsAdvantages />
            <AnalyticsCalculator />
            <AnalyticsContactForm />
          </main>
          <AnalyticsFooter />
        </div>
    </>
  );
}
